export const getMenuItems = (id) => {
    const url = __DEV__ ? `https://rec.altima-assurances.fr/api/menu_items/${id}` : `${window.location.origin}/api/menu_items/${id}`;
    console.debug(`GET ${url}`);
    return fetch(url).then(r => r.json())
}